export enum CriteriaIdType {
    USER_ID = 1,
    SUPER_GROUP_ID,
    PEER_GROUP_ID,
    SITE_ID,
    AREA_ID,
    REGION_ID,
    LOB_ID,
    QUEUE_ID,
    TEAM_ID, // managerId/userId,
    QUEUE_ID_2 = 36, // sometimes it's this or the other
    USER_ROLE_ID, // special usage
    TEAM_ROLE_ID, // special usage
    HIERARCHY, // special usage
}

export const CriteriaIdTypeNames = {
    [CriteriaIdType.USER_ID]: 'User',
    [CriteriaIdType.SUPER_GROUP_ID]: 'Super Group',
    [CriteriaIdType.PEER_GROUP_ID]: 'Peer Group',
    [CriteriaIdType.SITE_ID]: 'Site',
    [CriteriaIdType.AREA_ID]: 'Area',
    [CriteriaIdType.REGION_ID]: 'Region',
    [CriteriaIdType.LOB_ID]: 'Lob',
    [CriteriaIdType.QUEUE_ID]: 'Queue',
    [CriteriaIdType.TEAM_ID]: 'Team',
    [CriteriaIdType.QUEUE_ID_2]: 'Queue 2',
    [CriteriaIdType.USER_ROLE_ID]: 'User Role',
    [CriteriaIdType.TEAM_ROLE_ID]: 'Team Role',
    [CriteriaIdType.HIERARCHY]: 'Hierarchy',
};
